import { render, staticRenderFns } from "./Adblock.vue?vue&type=template&id=49be2b04&scoped=true"
import script from "./Adblock.vue?vue&type=script&lang=js"
export * from "./Adblock.vue?vue&type=script&lang=js"
import style0 from "./Adblock.vue?vue&type=style&index=0&id=49be2b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be2b04",
  null
  
)

export default component.exports